// extracted by mini-css-extract-plugin
module.exports = {"container":"useNotification_container___YnAI"};